<template>
    <CustomButton :to="{ name: 'listMegaMenusCategories' }" label="Links.goBack" />
    <p class="page-title">Edition d'une mise en avant</p>
    <div class="form-container">
        <div class="justify-center">
            <div class="mx-auto shadow-md p-6 rounded-lg w-[90%] md:w-[80%] lg:w-[50%]">
                <FormKit
                    type="form"
                    :value="true"
                    :actions="false"
                    incomplete-message="Désolé, tous les champs ne sont pas remplis correctement."
                    @submit="submitHandler"
                >
                    <FormKit type="select"
                             name="category"
                             v-model="megaMenuData.category"
                             label="Choix de la catégorie *"
                             placeholder="Choisissez une catégorie"
                             validation="required"
                             :options="categories"
                             :validation-messages="{
                    required: 'La catégorie est obligatoire',
                  }"
                    />
                    <FormKit
                        type="text"
                        name="name"
                        v-model="megaMenuData.name"
                        label="Nom de la mise en avant *"
                        placeholder="Entrer un nom de la mise en avant"
                        validation="required|length:1,50"
                        :validation-messages="{
                required: 'Ce champ est obligatoire.',
                length: 'Ce champ doit contenir maximum 50 caractères.',
                }"
                    />
                   
                    <FormKit type="autocomplete"
                             name="propertyValue"
                             v-if="dataIsReady"
                             v-model="megaMenuData.propertyValueUuid"
                             label="Tag de recherche *"
                             placeholder="Choisissez une tag"
                             validation="required"
                             :options="searchTags"
                             :validation-messages="{
                    required: 'La tag est obligatoire',
                  }"
                    />
                 
                    <div class="w-full lg:w-3/4 ">
                        <label class="font-bold text-sm">Image *</label>
                        <UploadImage :image-preview-url="imageMenu ? imageMenu.url : getBaseUrl() + '/media/blank2.png'"
                                     @image-removed="onImageRemoved"
                                     @imageUploaded="onImageUpload"
                                     @error="onImageUploadError"/>
                    </div>

                    <div class="flex mt-[1.5rem]">
                        <FormKit
                            type="submit"
                            label="Modifier"
                            class="btn"
                            prefix-icon="check"
                        />
                    </div>
                </FormKit>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import ApiService from "@/_services/api.service";
import {onBeforeMount, onMounted, ref, watch} from "vue";
import router from "@/router";
import swal from "@/_helpers/swal";
import UploadImage from "@/components/forms/UploadImage.vue";
import CustomButton from "@/components/forms/CustomButton.vue";
import {useRoute} from "vue-router";
const propertyTagUuid = '3172dc3a-1ed9-468d-8cbc-dff34c441361';
let categories = ref([]);
let imageMenu = ref();
let dataIsReady = ref(false);
let megaMenuData =ref({
    name:'',
    propertyValueUuid:'',
    propertyValueLabel:'',
    category:''
});
const route = useRoute();

onBeforeMount(
    async () => {
        await fetchCategories();
        await fetchMegaMenuData(route.params.uuid)
    }
)

async function fetchCategories() {
    try {
        const response = await ApiService.get('categories?lvl=1');
        categories.value = response.data.data.map((item: never) => {
            return {
                label: item.name, value: item.uuid
            };
        });
    } catch (error) {
        swal.error('An error occurred');
    }
}

async function searchTags({search}) {
    if (!search || search.length < 3) {
        return [
            {
                label: megaMenuData.value.propertyValueLabel,
                value: megaMenuData.value.propertyValueUuid
            }
        ];
    }
    const fetchTags = await ApiService.get(`property_values?property.uuid=${propertyTagUuid}&value=${search || ''}&status=true`);
    return fetchTags.data.data.map((val: any) => {
        return {
            label: val.value,
            value: val.uuid
        }
    });
}
const onImageUpload = (image) => {
    imageMenu.value = image;
}
const onImageRemoved = () => {
    imageMenu.value = null;
}
const onImageUploadError = (errorMsg: string) => {
    swal.error(errorMsg);
}

function getBaseUrl() {
    return window.location.origin;
}

function submitHandler(data, formNode) {
    if(!imageMenu.value){
        swal.error('l\'image est  obligatoire');
        return;
    }
    const uuid = route.params.uuid.toString();
    return ApiService.patch("/mega_menu_categories",uuid, {
        uuid: uuid,
        name: data.name,
        image: imageMenu.value.uuid,
        propertyValue: data.propertyValue,
        category: data.category

    }).then(() => {
        swal.success("Mise en avant modifiée !", "");
        router.push({name: 'listMegaMenusCategories'});
    }).catch(({response}) => {
        response.data.errors.forEach((error) => {
            formNode.setErrors(null, {[error.property]: error.message});
            return false;
        });
    });
}

const fetchMegaMenuData = async (megaMenuUuid) => {
    try {
        const response = await ApiService.get("/mega_menu_categories/" + megaMenuUuid);
        megaMenuData.value.propertyValueUuid = response.data.data.propertyValue.uuid;
        megaMenuData.value.propertyValueLabel = response.data.data.propertyValue.value;
        megaMenuData.value.name = response.data.data.name;
        megaMenuData.value.category = response.data.data.category.uuid;
        imageMenu.value = response.data.data.image;
        dataIsReady.value=true;
        
    } catch (error) {
    }
};

</script>


